<template>
  <div>
    <div class="col-12 d-flex align-items-center justify-content-end new-user-header">
      <ul class="list-disable-header desktop-main-menu" :class="[(isDrawerOpen) ? 'active' : '', (user.account === 'user' && (isMobile) || (isIpad)) ? 'p-user-sec-mobile': '']">
        <li v-if="(isMobile) || (isIpad)" class="i-cre" id="i-cre">
          <em v-if="companyName">{{companyName.charAt(0)}}</em>
          <em v-if="!companyName">{{user.first_name.charAt(0)}}</em>
          <strong>{{ user.first_name }}</strong>
        </li>
        <li v-if="(isMobile) || (isIpad)"><router-link class="home-link" :to="{ name: 'impact'}" @click.native="openMenuDrawer()">HOME</router-link></li>
        <!-- <li v-if="isDowngradeUser" id="giving-story" v-tooltip.top="{ content: isDowngradeUser ? 'Reactivate your membership to access this' : 'Favourite a project to unlock!', class: 'normal-tooltip' }">GIVING STORIES</li> -->
        <li v-if="!isDowngradeUser"><router-link class="" :to="{ name: 'giving-stories'}" @click.native="openMenuDrawer()">GIVING STORIES</router-link></li>
        <li v-if="!isDowngradeUser"><router-link class="" :to="{ name: 'view-all-projects'}" @click.native="openMenuDrawer()">PROJECTS</router-link></li>
        <!-- <li v-if="isDowngradeUser" v-tooltip.top="{ content: 'Reactivate your membership to access this', class: 'normal-tooltip' }">PROJECTS</li> -->
        <!-- <li v-if="(isMobile) || (isIpad) && user.account === 'company'">
          <router-link class="" :to="{ name: 'billing-details'}">Billing</router-link>
        </li> -->
  <!--      <li v-if="user.account === 'company' && !isMobile && !isIpad " v-tooltip.top="{ content: isDowngradeUser ? 'Reactivate your membership to access this' : 'Create your first giving to unlock!', class: 'normal-tooltip' }">SHARE</li>-->
  <!--      <li v-if="user.account === 'company' && !isMobile && !isIpad " v-tooltip.top="{ content: isDowngradeUser ? 'Reactivate your membership to access this' : 'Create your first giving to unlock!', class: 'normal-tooltip' }">COMMUNITY</li>-->
  <!--      -->
        <li v-if="user.account === 'company' && !isMobile && !isIpad && totalGivingsammout > 0">
          <a href="#">Share</a>
          <ul class="sub-menu">
            <li v-if="isHivePartner === 0"><router-link class="" :to="{ name: 'invite'}">Refer a Friend</router-link></li>
            <li v-if="isHivePartner === 1"><router-link class="" :to="{ name: 'hive-builder'}">Refer a Friend</router-link></li>
            <!--                  <li v-if="isHivePartner === 1"><router-link class="" :to="{ name: 'hive-builder'}">Hive Builder</router-link></li>-->
            <li>
              <router-link class="" :to="{ name: 'giving-widget'}">Impact Widgets</router-link>
            </li>
            <li>
              <router-link class="" :to="{ name: 'campaign-settings'}">Giving Campaign</router-link></li>
            <li>
              <router-link class="" :to="{ name: 'gratitude-certificate'}">Gratitude Certificates</router-link>
            </li>
            <li>
              <router-link class="" :to="{ name: 'media-kit'}">Media Kit</router-link>
            </li>
          </ul>
        </li>
        <li v-if="user.account === 'company' && !isMobile && !isIpad && totalGivingsammout === 0" v-tooltip.top="{ content: totalGivingsammout > 0 ? '' : 'Create your first giving to unlock!', class: 'normal-tooltip' }">
          <a href="#" class="header-menu-disable">Share</a>
          <ul class="sub-menu" style="display: none">
            <li v-if="isHivePartner === 0"><router-link class="" :to="{ name: 'invite'}">Refer a Friend</router-link></li>
            <li v-if="isHivePartner === 1"><router-link class="" :to="{ name: 'hive-builder'}">Refer a Friend</router-link></li>
            <!--                  <li v-if="isHivePartner === 1"><router-link class="" :to="{ name: 'hive-builder'}">Hive Builder</router-link></li>-->
            <li>
              <router-link class="" :to="{ name: 'giving-widget'}">Impact Widgets</router-link>
            </li>
            <li>
              <router-link class="" :to="{ name: 'campaign-settings'}">Giving Campaign</router-link></li>
            <li>
              <router-link class="" :to="{ name: 'gratitude-certificate'}">Gratitude Certificates</router-link>
            </li>
            <li>
              <router-link class="" :to="{ name: 'media-kit'}">Media Kit</router-link>
            </li>
          </ul>
        </li>
        <li v-if="user.account === 'company' && !isMobile && !isIpad && totalGivingsammout > 0">
          <a href="#">Community</a>
          <ul class="sub-menu">
            <li><a href="https://www.b1g1.com/events/overview" target="_blank">Event Calendar</a></li>
            <li><a href="https://blog.b1g1.com/" target="_blank">Blog & Stories</a></li>
          </ul>
        </li>
      <li v-if="user.account === 'company' && !isMobile && !isIpad && totalGivingsammout === 0" v-tooltip.top="{ content: totalGivingsammout > 0 ? '' : 'Create your first giving to unlock!', class: 'normal-tooltip' }">
          <a href="#" class="header-menu-disable">Community</a>
          <ul class="sub-menu" style="display: none">
            <li><a href="https://www.b1g1.com/events/overview" target="_blank">Event Calendar</a></li>
            <li><a href="https://blog.b1g1.com/" target="_blank">Blog & Stories</a></li>
          </ul>
        </li>
        <span v-if="(isMobile) || (isIpad) && !isDowngradeUser">
          <a href="javascript:void(0)" class="pointer" v-if="(user.user_business.company_id !== null) && user.account !== 'company' && parseInt(user.user_business.is_admin)" @click="companyAccount()">SWITCH TO COMPANY ACCOUNT</a>
          <a href="javascript:void(0)" class="pointer" v-if="(user.user_business.company_id !== null) && user.account === 'company'" @click="personalAccount()">SWITCH TO PERSONAL ACCOUNT</a>
        </span>
        <span v-if="(isMobile) || (isIpad) && isDowngradeUser">
          <a href="javascript:void(0)" class="pointer" v-if="(user.user_business.company_id !== null) && user.account === 'company'">Switch to Personal Account</a>
        </span>
        <span v-if="(isMobile) || (isIpad)">
          <a class="white-btn" href="javascript:void(0)" @click="logout()">LOG OUT</a>
        </span>
      </ul>
  <!--    <div class="noti">-->
  <!--      <aside class="cart" v-tooltip.top="{ content: isDowngradeUser ? 'Reactivate your membership to access this' : '', class: 'normal-tooltip' }">-->
  <!--        <i class="fas fa-shopping-basket"></i>-->
  <!--      </aside>-->
  <!--      <aside class="bell">-->
  <!--        <i class="fas fa-bell"></i>-->
  <!--      </aside>-->
  <!--    </div>-->
      <div v-if="!isDowngradeUser" class="noti">
        <router-link :to="{ name: 'giving-cart'}">
          <aside class="cart">
            <div>
              <img src="/static/front/images/menu-images/basket-icon.svg" alt="" style="opacity: 0.4;">
            </div>
          </aside>
        </router-link>
      </div>
      <div v-else class="noti">
        <aside class="cart" v-tooltip.top="{ content: isDowngradeUser ? 'Reactivate your membership to access this' : 'Favorite a Project first!', class: 'normal-tooltip' }">
          <img src="/static/front/images/menu-images/basket-icon.svg" alt="" style="opacity: 0.4;">
        </aside>
        <!--      <aside class="bell">-->
        <!--        <i class="fas fa-bell"></i>-->
        <!--      </aside>-->
      </div>
      <div :class="user.account === 'company' ? 'user-sec' : 'user-sec p-user-sec'" v-if="user">
        <div v-if="user.account === 'company'">
          <span>{{companyName.charAt(0)}}</span>
          <h4>{{companyName}}</h4>
        </div>
        <div v-if="user.account !== 'company'">
          <span>{{user.first_name.charAt(0)}}</span>
          <h4>{{user.first_name}}</h4>
        </div>
        <div v-if="!isDowngradeUser">
          <div v-if="user.account === 'company'">
            <p>Business Account</p>
            <ul>
              <li style="border-bottom: 1px solid #ddd;" v-if="isAdminLogin"><a class="pointer" @click="adminAccount()">Back to Admin Account</a></li>
              <li style="border-bottom: 1px solid #ddd;" v-if="user.user_business.company_id"><a class="pointer" @click="personalAccount()">Switch to Personal Account</a></li>
              <li style="border-bottom: 1px solid #ddd;" v-if="user.user_business.company_id"><a href="javascript:void(0)" @click="personalAccountProfile()">Personal Profile & Settings</a></li>
              <li class="menu-ti">Company</li>
              <li><router-link class="" :to="{ name: 'business.company.profile'}">Company Profile</router-link></li>
              <li><router-link class="" :to="{ name: 'impact.history'}">Impact History</router-link></li>
              <li><router-link class="" :to="{ name: 'billing-details'}">Billing</router-link></li>
              <li><a href="javascript:void(0)" @click="logout()"><img src="/static/front/images/drop-down-icon/log-out.svg" alt="">Log Out</a></li>
  <!--            <li class="switch-menu"><a class="pointer" :href="oldHost" target="_blank">SWITCH TO CLASSIC VERSION</a></li>-->
            </ul>
          </div>
          <div v-if="user.account !== 'company'">
            <p>Personal Account</p>
            <ul>
              <li style="border-bottom: 1px solid #ddd;" v-if="isAdminLogin"><a class="pointer" @click="adminAccount()">Back to Admin Account</a></li>
              <li style="border-bottom: 1px solid #ddd;" v-if="user.user_business.company_id && parseInt(user.user_business.is_admin)"><a class="pointer" @click="companyAccount()">Switch To Company Account</a></li>
              <li style="border-bottom: 1px solid #ddd;"><router-link class="" :to="{ name: 'business.personal.profile'}">Personal Profile & Settings</router-link></li>
              <li><a href="javascript:void(0)" @click="logout()"><img src="/static/front/images/drop-down-icon/log-out.svg" alt="">Log Out</a></li>
  <!--            <li class="switch-menu"><a class="pointer" :href="oldHost" target="_blank">SWITCH TO CLASSIC VERSION</a></li>-->
            </ul>
          </div>
        </div>
        <div v-if="isDowngradeUser">
          <div v-if="user.account === 'company'">
            <p>Business Account</p>
            <ul class="menu-disable-list">
              <li style="border-bottom: 1px solid #ddd;" v-if="isAdminLogin"><a class="pointer" @click="adminAccount()">Back to Admin Account</a></li>
              <li style="border-bottom: 1px solid #ddd;" v-if="user.user_business.company_id">Switch to Personal Account</li>
              <li style="border-bottom: 1px solid #ddd;">Company Profile & Settings</li>
              <li class="menu-ti">Company</li>
              <li>Company Profile</li>
              <li>Impact History</li>
              <li>Billing</li>
              <li><a href="javascript:void(0)" @click="logout()"><img src="/static/front/images/drop-down-icon/log-out.svg" alt="">Log Out</a></li>
              <!-- <li class="switch-menu"><a class="pointer" :href="oldHost" target="_blank">SWITCH TO CLASSIC VERSION</a></li> -->
            </ul>
          </div>
          <div v-if="user.account !== 'company'">
            <p>Personal Account</p>
            <ul>
              <li style="border-bottom: 1px solid #ddd;" v-if="isAdminLogin"><a class="pointer" @click="adminAccount()">Back to Admin Account</a></li>
              <li style="border-bottom: 1px solid #ddd;" class="no-a-tag">Personal Profile & Settings</li>
              <li><a href="javascript:void(0)" @click="logout()"><img src="/static/front/images/drop-down-icon/log-out.svg" alt="">Log Out</a></li>
              <!-- <li class="switch-menu"><a class="pointer" :href="oldHost" target="_blank">SWITCH TO CLASSIC VERSION</a></li> -->
            </ul>
          </div>
        </div>
      </div>
      <div class="user-sec" v-else>
        <span>G</span>
        <h4>Guest <a href="#" @click="logout()" style="color: white; font-size: 18px;"><i class="fas fa-sign-out-alt"></i></a></h4>
      </div>
    </div>
    <div class="overly-close" @click="toggleRightMenu"></div>
    <RouterLink to="" class="overly-close" @click.native="closeMenu"></RouterLink>
    <menuCustom :partner_level="partner_level" :user="user" :isHivePartner="isHivePartner" :companyName="companyName" ></menuCustom>
  </div>
</template>
<script>
import Vue from 'vue'
import store from '../../store'
import config from '../../config/app'
import userApi from '../../api/user'
import companyApi from '../../api/company'
import Tooltip from 'vue-directive-tooltip'
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css'
import jQuery from 'jquery'
import contributionApi from '../../api/contribution'
import storyAPI from '../../api/story'
import menuCustom from '../business/menu-custom.vue'
window.jQuery = jQuery
Vue.use(Tooltip)

export default {
  data () {
    return {
      user: store.getters.currentUser,
      type: (store.getters.currentUser) ? store.getters.currentUser.account : null,
      company: null,
      isValidCurrentPage: (this.$route.path !== '/sign-up' && this.$route.path !== '/join-business-geniusu' && this.$route.name !== 'public-business-register' && this.$route.name !== 'payment-redirect' && this.$route.name !== 'campaign-payment-success') ? 1 : 0,
      notShowHeaderRouteNames: ['my-hive', 'payment-redirect', 'public-business-register'],
      partner_level: (store.getters.currentUser && store.getters.currentUser.companydata) ? store.getters.currentUser.companydata.latest_impact_partner_level : null,
      showHeaderMenu: false,
      isHivePartner: 0,
      isMobile: store.getters.isMobile,
      isDowngradeUser: store.getters.currentUser ? store.getters.currentUser.role_id === 1 : false,
      isDrawerOpen: false,
      isAdminLogin: false,
      companyName: '',
      totalImpact: 0,
      totalGivings: 0,
      totalGivingsammout: 0,
      isIpad: null,
      oldHost: 'https://www.b1g1.com/login',
      form: {
        username: localStorage.getItem('YUJAqQWVZTRRJsvPpKIG') ? localStorage.getItem('YUJAqQWVZTRRJsvPpKIG') : null,
        password: localStorage.getItem('VxdqRJrxxGTZSSwFmmOU') ? localStorage.getItem('VxdqRJrxxGTZSSwFmmOU') : null
      },
      filters: {
        limit: 5,
        page: 1,
        order_automate: '',
        order_automate_by: '',
        is_giving_monthly: '1',
        order_by_field: 'updated_at',
        order_by: 'desc'
      }
    }
  },
  components: {
    menuCustom
  },
  created () {
    // Start of b1g1 Zendesk Widget script
    /* let zendeskjs = document.createElement('script')
    zendeskjs.setAttribute('id', 'ze-snippet')
    zendeskjs.setAttribute('src', 'https://static.zdassets.com/ekr/snippet.js?key=b69d5261-aa9f-4270-a379-95948de761d6')
    document.body.appendChild(zendeskjs) */
    // End of b1g1 Zendesk Widget script
    if (localStorage.getItem('login_user_type') !== '' && localStorage.getItem('login_user_type') === 'admin') {
      this.isAdminLogin = true
    }
    let companyPromise = null
    let contributionsPromise = this.loadContributions()
    let storyPromise = this.loadStories()
    if (store.getters.isCompanyAccount) {
      companyPromise = companyApi.getCompanyById(this.user.user_business.company_id).then((response) => {
        this.company = response
        this.companyName = (this.company) ? (this.company.company_name) ? this.company.company_name : '' : ''
        this.isHivePartner = (this.company) ? (this.company.is_hive_partner) ? 1 : 0 : 0
      })
    }
    Promise.all([companyPromise, contributionsPromise, storyPromise]).then(() => {
      if (/iPad|iPod/i.test(navigator.userAgent)) {
        this.isIpad = true
      } else {
        this.isIpad = false
      }
      if (this.notShowHeaderRouteNames.includes(this.$route.name)) {
        this.showHeaderMenu = false
      } else {
        this.showHeaderMenu = true
      }
    })
  },
  methods: {
    companyAccount () {
      userApi.switchAccount(this.isAdminLogin).then((response) => {
        if (response === true) {
          companyApi.getCompanyById(this.user.user_business.company_id).then((response) => {
            this.company = response
            this.companyName = (this.company) ? (this.company.company_name) ? this.company.company_name : '' : ''
            this.isHivePartner = (this.company) ? (this.company.is_hive_partner) ? 1 : 0 : 0
            this.$store.dispatch('toCompanyAccount')
            this.$store.dispatch('getCurrentUser')
            this.$router.push({name: 'home'})
            window.location.replace(config.host + '/impact')
          })
        }
      })
    },
    personalAccount () {
      userApi.switchAccount(this.isAdminLogin).then((response) => {
        if (response === true) {
          this.$store.dispatch('toPersonalAccount')
          this.$store.dispatch('getCurrentUser')
          this.$router.push({name: 'home'})
          window.location.replace(config.host + '/impact')
        }
      })
    },
    personalAccountProfile () {
      userApi.switchAccount(this.isAdminLogin).then((response) => {
        if (response === true) {
          this.$store.dispatch('toPersonalAccount')
          this.$store.dispatch('getCurrentUser')
          this.$router.push({name: 'home'})
          window.location.replace(config.host + '/personal/profile')
        }
      })
    },
    openMenuDrawer () {
      this.isDrawerOpen = !this.isDrawerOpen
    },
    loadContributions () {
      return contributionApi.get({impact_type: this.type, limit: -1}, ['Impact', 'Project', 'Story']).then((response) => {
        this.totalImpact = response.length > 0 ? response.map(i => i.beneficiaries).reduce((p, n) => p + n) : 0
        this.totalGivings = response.length > 0 ? response.map(i => i.amt_total_usd).reduce((p, n) => p + n) : 0
        this.totalGivingsammout = response.length > 0 ? response.map(i => i.amt_total_usd).reduce((p, n) => p + n) : 0
        this.totalGivings = this.totalGivings.toFixed(2)
      })
    },
    loadStories () {
      if (this.user) {
        let stories = []
        return new Promise((resolve, reject) => {
          storyAPI.getUserStories(this.user.id, ['Company', 'Project', 'Project.ImageSquare', 'Project.ImageRectangle', 'Impact', 'Contributions'], this.filters).then((response) => {
            this.storyMeta = response.meta
            if (this.filters.is_giving_monthly === '') {
              this.activeStoryCount = response.data.length
            }
            if (this.totalGivingsammout === 0) {
              this.totalGivingsammout = response.meta.total
            }
            response.data.forEach((story) => {
              story.story_text = story.story_text.replace('When ', '')
              let totalBeneficiaries = 0
              let projectId = story.project_id
              let isBundle = story.project ? parseInt(story.project.is_bundle) : 0
              story.contributions.forEach((contribution) => {
                if (isBundle) {
                  totalBeneficiaries += contribution.beneficiaries
                } else if (contribution.project_id === projectId) {
                  totalBeneficiaries += contribution.beneficiaries
                }
              })
              story.show_share = false
              story.totalBeneficiaries = totalBeneficiaries
              story.qty = 1
              story.image = story.project.image_square ? story.project.image_square.image_name : story.giving_story_image
              if (story.project_id !== 0 && story.project) stories.push(story)
            })
            this.stories = stories
            resolve(stories)
          })
        })
      }
    },
    logout () {
      this.$store.dispatch('localClear')
      this.$store.dispatch('logout')
      window.location.replace(config.host + '/login')
    },
    toggleRightMenu () {
      document.body.classList.toggle('right-menu-open')
      document.body.classList.remove('left-menu-open')
      this.closeAllDropdowns()
    },
    adminAccount () {
      console.log(this.form)
      let data = {
        username: atob(this.form.username),
        password: atob(this.form.password)
      }
      this.$store.dispatch('login', data).then(() => {
        location.href = config.host
      })
    }
  }
}
</script>

<style>
  a aside {
    color: black;
  }
  .pointer {
    cursor: pointer;
  }
  /* .tooltip-content{
    background: #363537;
    color: #fff;
    padding: 10px;
  }
  */
  @media(max-width: 767px){
    .new-user-header .noti{
      margin-right: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/business/HeaderDisable.vue